export default [
  {
    title: "Place an order",
    name: "place-an-order",
    icon: "ExternalLinkIcon",
    href: "/order-form",
    target: "_blank",
    tagVariant: "light-warning",
  },
];
